import { AppBar, Box, Button, Stack, ToggleButton, ToggleButtonGroup, Toolbar } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import chblogo from "../assets/chb-logo.png";
import RtfUploadDialog from "../dialogs/RtfUploadDialog";
import { useTranslation } from "i18n/LanguageContext";

export default function MenuBar() {
  const navigate = useNavigate();
  const [rtfDialogOpen, setRtfDialogOpen] = useState(false);
  const { t, lang, setLang } = useTranslation();

  const handleLangChange = (_event, next) => {
    if (next) setLang(next);
  };

  return (
    <Box mb={2}>
      <AppBar position="fixed" elevation={2} style={{ background: "#ffffff" }}>
        <Toolbar>
          <Stack
            justifyContent="space-between"
            alignItems="center"
            direction={"row"}
            sx={{ width: "100%" }}
          >
            <Stack direction="row" alignItems="center">
              <Box ml={2} my={1} mr={5}>
                <img src={chblogo} alt="chblogo" height="30px" />
              </Box>
            </Stack>
            <Stack spacing={2} direction={"row"} alignItems="center">
              <ToggleButtonGroup
                value={lang}
                exclusive
                onChange={handleLangChange}
                size="small"
                aria-label={t("menu.language")}
              >
                <ToggleButton value="fr" sx={{ px: 1.5, py: 0.25, fontWeight: 600 }}>
                  FR
                </ToggleButton>
                <ToggleButton value="de" sx={{ px: 1.5, py: 0.25, fontWeight: 600 }}>
                  DE
                </ToggleButton>
              </ToggleButtonGroup>
              <Button
                variant={"outlined"}
                color={"secondary"}
                onClick={() => navigate(-1)}
              >
                {t("menu.back")}
              </Button>
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>

      <RtfUploadDialog
        open={rtfDialogOpen}
        handleClose={() => setRtfDialogOpen(false)}
      />
    </Box>
  );
}
